module.exports = __webpack_public_path__ + "static/media/icon_cart.b5778a6c.svg";